import React, { useState } from 'react';
import '../../styles/main.scss';
import {
  PresentationChartBarIcon,
  QuestionMarkCircleIcon
} from '@heroicons/react/solid';

import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ isExpanded, onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOracleModernizer = () => {
    navigate('/pb-conversion');
  };

  const handleHelp = () => {
    // Handle help action
  };

  return (
    <>
       <div 
        className={`sidebar ${isExpanded ? 'expanded' : ''}`}
        onMouseEnter={() => onToggle(true)}
        onMouseLeave={() => onToggle(false)}
      >
        <div className="sidebar-menu">
          {/* Oracle Forms Modernization */}
          <button
            className={`sidebar-item ${location.pathname === '/pb-conversion' ? 'active' : ''}`}
            onClick={handleOracleModernizer}
          >
            <div>
              <PresentationChartBarIcon className="h-6 w-6" />
            </div>
            <span className="sidebar-label">
              Oracle Forms Modernization
            </span>
          </button>

          {/* Help */}
          <button
            className="sidebar-item"
            onClick={handleHelp}
          >
            <div>
              <QuestionMarkCircleIcon className="h-6 w-6" />
            </div>
            <span className="sidebar-label">
              Help
            </span>
          </button>
        </div>
      </div>

   
      
      {/* Overlay for mobile */}
      {isExpanded && (
        <div 
          className="sidebar-overlay"
          onClick={() => onToggle(false)}
        />
      )}
    </>
  );
};

export default Sidebar;